export default __webpack_public_path__ + "static/step2-e86944c1139099ba0c7e73152d5fdbde.webp";